var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-carousel',{attrs:{"interval":5000,"arrow":"always","height":_vm.height}},_vm._l((_vm.banner),function(item){return _c('el-carousel-item',{key:item.id},[_c('a',{attrs:{"href":item.link,"target":"_blank"}},[_c('div',{staticClass:"banner",style:({backgroundImage: `url(${item.image}`})})])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }